import { createSlice } from "@reduxjs/toolkit";

interface InfoState {
  id: string;
  customer: string;
}

const initialState: InfoState = {
  id: "",
  customer: "",
};

export const infoSlice = createSlice({
  name: "info",
  initialState,
  reducers: {
    setId(state, action) {
      state.id = action.payload;
    },
    setCustomer(state, action) {
      state.customer = action.payload;
    },
  },
});

export const { setId, setCustomer } = infoSlice.actions;

export default infoSlice.reducer;
